import React, {useContext, useEffect} from "react";
import {useHistory} from "react-router-dom";
import moment from "moment";
import Grid from "@material-ui/core/Grid";
import {CData} from "src/Data";
import * as Dati from "src/Dati";
import * as Glob from "src/Globale";
import {Trad} from "src/components/";
import ChiamaWeb, {CChiamaWebParametri} from "src/ChiamaWeb";
import useReducerOnChange from "src/hooks/ReducerOnChange";
import {_Accordion, _AddClientButton, _ButtonAPI} from "..";
import {_Autocomplete} from "../../form";
import {AlertDialogContext} from "../../providers/AlertDialogProvider";

class CDataPolicyCAR {
    public ID_AnagBeneficiario: number = 0;
    public Durata: number = 0;
    public LuogoEsecuzione: string = "";
}

export const _PolicyCARAccordion = (): JSX.Element => {
    const history = useHistory();
    const {ShowDialog} = useContext(AlertDialogContext);

    const [formData, setFormData] = useReducerOnChange<Dati.CDatiPolizza>({
        ...new Dati.CDatiPolizza(),
        ID_TipoRamo: 0,
        ID_AnagPOS: Glob.GetSessione().ID_Anag,
        ID_TipoProdotto: 101,
        CoAssicurazioneJSON: "[]"
    });

    const [policyData, setPolicyData] = useReducerOnChange<CDataPolicyCAR>(new CDataPolicyCAR());

    useEffect(() => {
        setFormData({Type: "OnChangeFromValue", Name: "CoAssicurazioneJSON", Value: "[]"});
        getProductBinder();
    }, [formData.ID_AnagPOS]);

    useEffect(() => {
        setPolicyData({Type: "OnChangeFromValue", Name: "ID_TipoProdotto", Value: 101});
    }, [formData.ID_AnagContraente]);

    const getProductBinder = (): void => {
        const Param: CChiamaWebParametri = {
            URL: `/api/polizza/GetBinderProdotto?ID_AnagA=${formData.ID_AnagPOS}&ID_TipoProdotto=${formData.ID_TipoProdotto}&dataEffetto=${moment(formData.DataEffetto).utc().format()}`,
            OnRis: onGetProductBinder,
            OnErrore: (sender: ChiamaWeb, error: Error) => onApiError(error)
        };
        new ChiamaWeb().Chiama(Param);
    };

    const onGetProductBinder = (sender: ChiamaWeb, data: Dati.CRisAPISemplice<string>) => {
        if (formData.ID_AnagPOS > 0)
        {
            setFormData({
                Type: "OnChangeFromValue",
                Name: "Dato.CoAssicurazioneJSON",
                Value: getSingleInsurance(data.Dato)
            });
            setFormData({
                Type: "OnChangeFromValue",
                Name: "CoAssicurazioneJSON",
                Value: getSingleInsurance(data.Dato)
            });
        }
    };

    const getSingleInsurance = (productBinderJSON: string): string => {
        if (productBinderJSON) {
            const productBinder: Dati.CDatoBinderProdottoCoAssicurazione[] = JSON.parse(productBinderJSON);

            if (productBinder.length == 1) {
                const coInsurance = new Dati.CDatoCoAssicurazione();
                coInsurance.Delegataria = true;
                coInsurance.Quota = 100;
                coInsurance.ID_Anag = productBinder[0].ID_AnagCompagnia;
                coInsurance.ID_Binder = productBinder[0].ID_Binder;
                coInsurance.ID_BinderCompagnia = productBinder[0].ID_BinderCompagnia;

                return JSON.stringify([coInsurance]);
            } else {
                return productBinderJSON;
            }
        }
        
        if (formData.ID_AnagPOS > 0)
        {
            ShowDialog("ERRORE", Trad.Trad("BINDER ERRORE"), "error");
        }
        
        return "[]";
    };

    const getFormData = (): Dati.CIngrAPI<Dati.CDatiPolizza> => {
        const data = new Dati.CIngrAPI<Dati.CDatiPolizza>();
        const duration = 365;
        const startDate = new CData(new Date(Date.now()), true).Data;
        const endDate = new CData(startDate, true).AddGiorni(duration).Data;

        data.Dato = formData;
        data.Dato.DataEffetto = startDate;
        data.Dato.DataFine = endDate;
        data.Dato.DatiPolizza = JSON.stringify({
            ...policyData,
            LuogoEsecuzione: "Vedasi oggetto garanzia",
            Durata: duration,
            DataEffetto: startDate,
            DataFine: endDate,
            DataInizioLavori: startDate,
            DataFineLavori: endDate,
            DataStipula: startDate
        });

        return data;
    };

    const onClickSave = (data: Dati.CRisAPIDatoTipiInfo_Polizza) => {
        if (data.Errore) {
            ShowDialog("ERRORE", Trad.Trad(data.ErrTesto), "error");
        } else {
            history.push(`/anagrafica/${formData.ID_AnagContraente}/polizzacar/${data.ID_Chiave}`);
        }
    };

    const onApiError = (error: Error) => {
        ShowDialog("ERRORE", error.message, "error");
    };

    const onAddClient = (val: string) => {
        setFormData({Type: "OnChangeFromValue", Name: "ID_AnagBeneficiario", Value: val});
    };

    const checkValidity = (): boolean => {
        return (
            formData.ID_AnagContraente > 0 &&
            formData.ID_AnagPOS > 0 &&
            formData.ID_TipoProdotto > 0 &&
            formData.CoAssicurazioneJSON != "[]"
        );
    };

    const isFormValid = checkValidity();

    return (
        <_Accordion Title="Polizza" Id="policy" defaultExpanded>
            <Grid container>
                <Grid item xs={12}>
                    <form noValidate autoComplete="off">
                        <Grid container spacing={4}>
                            <Grid item xs={12} md={4}>
                                <_Autocomplete
                                    Value={formData.ID_AnagPOS}
                                    Name="ID_AnagPOS"
                                    Label="POS"
                                    OnChange={(e, val) => setFormData({Type: "OnChangeFromValue", Name: e, Value: val})}
                                    Url="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca="
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <_Autocomplete
                                    Value={formData.ID_AnagContraente}
                                    Name="ID_AnagContraente"
                                    Label="Contraente"
                                    OnChange={(e, val) => setFormData({Type: "OnChangeFromValue", Name: e, Value: val})}
                                    Url="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca="
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <_AddClientButton OnAddClient={onAddClient}>
                                    <_Autocomplete
                                        Value={policyData.ID_AnagBeneficiario}
                                        Name="ID_AnagBeneficiario"
                                        Label="Subappaltatore"
                                        OnChange={(e, val) => setPolicyData({
                                            Type: "OnChangeFromValue",
                                            Name: e,
                                            Value: val
                                        })}
                                        Url="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca="
                                    />
                                </_AddClientButton>
                            </Grid>
                        </Grid>
                        <Grid container spacing={4} justify="flex-end">
                            <Grid item>
                                <_ButtonAPI Testo={Trad.Trad("Nuovo")} URL="/api/polizza/salvapolizza"
                                            OnInvio={getFormData} OnClick={onClickSave} OnErrore={onApiError}
                                            Attivo={isFormValid}/>
                            </Grid>
                        </Grid>
                    </form>
                </Grid>
            </Grid>
        </_Accordion>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/NewPolicy/PolicyCARAccordion.tsx